/* import Firebase */
import firebase from "firebase/app";
import "firebase/auth";
import 'firebase/firestore';
import 'firebase/firebase-functions'
import store from "./store";

// Initialize Firebase
const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
};

export default {
  init() {
    firebase.initializeApp(config);
    firebase.analytics();
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
  },

  // ログイン状態の変更に応じてstoreのログイン情報を変更するメソッド
  async onAuth() {
    await firebase.auth().onAuthStateChanged(async user => {
      user = user ? user : {};
      await store.dispatch('auth/setUser', user)
    });
  },
}

